<template>
  <div class="modal fade" id="modalQuestionSend" role="dialog">
    <div class="modal-dialog modal-xl" role="document">
      <!-- Modal content-->
      <div class="modal-content modal-dialog-centered" role="document">
        <div class="row modal-container">
          <div class="modal-header">
            <a type="button" class="btn-close-modal" data-dismiss="modal">
              <ion-icon name="close"></ion-icon>
            </a>
            <span class="title-modal">
              Objetivos da Empresa
            </span>
            <span class="subtitle-modal">Preencha os campos antes, para gerar uma venda</span>
          </div>

          <form class="modal-body" @submit.prevent="dataGoalSend">
            <input-multi-select id="doresSelect" :isRequired="true" style="margin-bottom: 20px;" col="12"
                                label="Qual é a dor/desafio do cliente?"
                                :options="doresSelectItems"
                                @selectedOptions="value => selectedDoresItems = value"
                                :input-error="validateErrorInput.doresSelect"/>

            <input-text id="doresTextOther" v-if="hasForceTextDores" :isRequired="true"
                        style="margin-top: -5px;" col="12" type="text"
                        placeholder="Descreva qual é a dor/desafio do cliente"
                        label="Outra dor/desafio do cliente"
                        @contentText="value => otherDoresItems = value"
                        :input-error="validateErrorInput.textDoresOther"/>

            <input-multi-select id="objetivosSelect" :isRequired="true" style="margin-bottom: 20px;" col="12"
                                label="Qual é o objetivo/resultado esperado pelo cliente?"
                                :options="objetivosSelectItems"
                                @selectedOptions="value => selectedObjetivosItems = value"
                                :input-error="validateErrorInput.objetivosSelect"/>

            <input-text id="objetivosTextOther" v-if="hasForceTextObjetivos"
                        :isRequired="true"
                        style="margin-top: -5px;" col="12" type="text"
                        placeholder="Descreva qual é a objetivo/resultado esperado pelo cliente"
                        label="Outro objetivo/resultado esperado pelo cliente"
                        @contentText="value => otherObjetivosItems = value"
                        :input-error="validateErrorInput.textObjetivosOther"/>

            <input-multi-select id="featuresCourtesySelect" :isRequired="true" style="margin-bottom: 20px;" col="12"
                                label="Ganhou alguma feature de cortesia?"
                                :options="featuresCourtesySelectItems"
                                @selectedOptions="value => selectedFeaturesCourtesyItems = value"
                                :input-error="validateErrorInput.featuresCourtesySelect"/>

            <input-select id="selectAnyItemAgreed" :isRequired="true" style="margin-bottom: 20px;" col="12"
                          :options="anyItemAgreedItems"
                          label="Algum item acordado de forma diferenciada e/ou necessário ações específicas"
                          @selectedOption="value => selectedAnyItemAgreed = value"
                          :input-error="validateErrorInput.anyItemAgreed"/>

            <input-textarea id="contentTextareaItemAgreed" v-if="selectedAnyItemAgreed" :isRequired="true" col="12"
                            placeholder="Digite"
                            label="Especifique os itens acordados"
                            @contentTextarea="value => contentTextareaItemAgreed = value"
                            :input-error="validateErrorInput.textareaItemAgreed"/>

            <input-select id="selectUsedScales" :isRequired="true" style="margin-bottom: 20px;" col="3"
                          :options="usedScalesItems"
                          label="Utilizará escalas?"
                          @selectedOption="value => selectedUsedScales = value"
                          :input-error="validateErrorInput.usedScales"/>

            <btn-search type="submit" style="float: right;" label="Enviar" whichSide="right"
                        have-loading="true"
                        :loading="loadingSendGoal"/>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputMultiSelect from "../components/inputs/inputMultiSelect.vue";
import InputSelect from "../components/inputs/inputSelect.vue";
import InputText from "../components/inputs/inputText.vue";
import {SELECT_YES_OR_NO} from '../../../assets/js/index'
import InputTextarea from "../components/inputs/inputTextarea.vue";
import BtnSearch from "../components/buttons/btnSearch.vue";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../requestConfig";
import {SALE_OBJECTIVES} from "../../../urlConfig";
import swal from "sweetalert";
import BtnDefault from "../components/buttons/btnDefault.vue";

export default {
  name: "modalQuestionSend",
  components: {BtnDefault, BtnSearch, InputTextarea, InputSelect, InputMultiSelect, InputText},
  props: {
    objToModalFeature: {
      required: true,
    },
    doresSelect: {
      required: true,
    },
    objetivosSelect: {
      required: true,
    },
    featuresCourtesySelect: {
      required: true,
    },
  },
  data() {
    return {
      doresSelectItems: [],
      objetivosSelectItems: [],
      featuresCourtesySelectItems: [],
      usedScalesItems: [
        {
          name: 'Selecione',
          id: '',
        }, ...SELECT_YES_OR_NO
      ],
      anyItemAgreedItems: [
        {
          name: 'Selecione',
          id: '',
        }, ...SELECT_YES_OR_NO
      ],
      selectedDoresItems: [],
      otherDoresItems: '',
      selectedObjetivosItems: [],
      otherObjetivosItems: '',
      selectedFeaturesCourtesyItems: [],
      selectedUsedScales: '',
      selectedAnyItemAgreed: '',
      contentTextareaItemAgreed: '',
      loadingSendGoal: false,
      validateErrorInput: {
        doresSelect: false,
        objetivosSelect: false,
        featuresCourtesySelect: false,
        usedScales: false,
        anyItemAgreed: false,
        textareaItemAgreed: false,
        textDoresOther: false,
        textObjetivosOther: false,
      },
    }
  },
  methods: {
    dataGoalSend() {
      this.validateErrorInput = {
        doresSelect: false,
        objetivosSelect: false,
        featuresCourtesySelect: false,
        usedScales: false,
        anyItemAgreed: false,
        textareaItemAgreed: false,
        textDoresOther: false,
        textObjetivosOther: false,
        additionalInput1: false,
        additionalInput2: false
      };

      if (!this.selectedDoresItems.length && !this.otherDoresItems) {
        this.validateErrorInput.doresSelect = true;
      }

      if (!this.selectedObjetivosItems.length && !this.otherObjetivosItems) {
        this.validateErrorInput.objetivosSelect = true;
      }

      if (!this.selectedFeaturesCourtesyItems.length) {
        this.validateErrorInput.featuresCourtesySelect = true;
      }

      if (this.selectedUsedScales === '') {
        this.validateErrorInput.usedScales = true;
      }

      if (this.selectedAnyItemAgreed === '') {
        this.validateErrorInput.anyItemAgreed = true;
      }

      if (this.selectedAnyItemAgreed && !this.contentTextareaItemAgreed) {
        this.validateErrorInput.textareaItemAgreed = true;
      }

      if (this.hasForceTextDores && !this.otherDoresItems) {
        this.validateErrorInput.textDoresOther = true;
      }

      if (this.hasForceTextObjetivos && !this.otherObjetivosItems) {
        this.validateErrorInput.textObjetivosOther = true;
      }

      if (Object.values(this.validateErrorInput).includes(true)) {
        return;
      }

      this.dataGoal();
    },
    dataGoal() {
      this.loadingSendGoal = true

      if (!this.hasForceTextDores) {
        this.otherDoresItems = '';
      }

      if (!this.hasForceTextObjetivos) {
        this.otherObjetivosItems = '';
      }

      if (!this.selectedAnyItemAgreed) {
        this.contentTextareaItemAgreed = '';
      }

      const doresItems = this.selectedDoresItems.map(obj => obj.id);
      const objetivosItems = this.selectedObjetivosItems.map(obj => obj.id);
      const featuresCourtesyItems = this.selectedFeaturesCourtesyItems.map(obj => obj.id);

      let objToSend = {
        companyId: this.objToModalFeature.companyId,
        dores: doresItems,
        objetivos: objetivosItems,
        features: featuresCourtesyItems,
        otherDor: this.otherDoresItems,
        otherObjetivo: this.otherObjetivosItems,
        usingSchedule: this.selectedUsedScales,
        customSpecification: this.selectedAnyItemAgreed,
        specification: this.contentTextareaItemAgreed,
      };

      REQUEST_SERVICE.requestContext("POST", SALE_OBJECTIVES, this.objToModalFeature.context, objToSend)
        .then((response) => {
          UTIL_SERVICE.console("RESULT SALE_OBJECTIVES:", response.data);

          this.loadingSendGoal = false;

          swal("Sucesso!", 'Objetivos da empresa preenchidos', "success");
          $("#modalQuestionSend").modal('hide');
          $("#modalFeatureType").modal();

          this.$route.params.goalsFulfilled = true;
        })
        .catch((reason) => {
          this.loadingSendGoal = false;
          swal("Aviso", 'Erro ao preencher os objetivos', "error");
        });
    }
  },
  watch: {
    doresSelect(newValue) {
      this.doresSelectItems = newValue;
    },
    objetivosSelect(newValue) {
      this.objetivosSelectItems = newValue;
    },
    featuresCourtesySelect(newValue) {
      this.featuresCourtesySelectItems = newValue;
    },
  },
  computed: {
    hasForceTextDores() {
      return this.selectedDoresItems.some(selectedDoresItems => selectedDoresItems.forceText)
    },
    hasForceTextObjetivos() {
      return this.selectedObjetivosItems.some(selectedObjetivosItems => selectedObjetivosItems.forceText)
    }
  },
}
</script>

<style lang="scss">

#modalQuestionSend {
  .modal-dialog {
    width: 900px;

    .modal-content {
      box-shadow: none !important;
      border: none !important;
      border-radius: 10px !important;
      padding: 20px 30px;

      .modal-container {
        margin: 0 !important;

        .modal-header {
          position: relative;
          border: none;
          padding: 0 0 10px 0;
          border-bottom: 1px solid #E6E9EC;

          .btn-close-modal {
            position: absolute;
            right: 0;
            top: 0;
            height: 21px;
            color: var(--high-blue);

            &:hover {
              color: #201987;
            }

            ion-icon {
              font-size: 21px;
            }
          }

          .title-modal {
            display: flex;
            align-items: flex-start;
            font-size: 21px;
            font-weight: 700;
            color: #191919;
          }

          .subtitle-modal {
            font-size: 14px;
            font-weight: 400;
            color: var(--dark-gray);
          }
        }
      }

      .modal-body {
        margin-top: 10px;
        padding: 0;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalQuestionSend.vue